import React from 'react';

const Profile = () => {
    return (
        <div>
            dgfgdfg
        </div>
    );
};

export default Profile;